/*jshint esversion: 8 */
import React, { Component } from "react";
// import clsx from  'clsx';

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

// store
import { observer } from "mobx-react";
import LocalStore from "./LocalStore";
import store from "../../../components/stores/Store";
import { toJS } from "mobx";

const styles = {};

class AddDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordInfo: {},
    };

    // 通用
    this.addRecord = this.addRecord.bind(this);
    this.updateRecord = this.updateRecord.bind(this);
  }

  async componentDidMount() { }

  async addRecord() {

    for (let index = 0; index < LocalStore.tableFields.length; index++) {
      const element = LocalStore.tableFields[index];
      if (!element.notEmptyWhenCreating) continue;
      const value = this.state.recordInfo[element.sid];
      if ([undefined, null]
        .includes(value)) {
        store.openMessageDialogOpen(`'${element.label}' 不能为空`);
        return;
      }
      if ((typeof value) === 'string' && value.trim() === '') {
        store.openMessageDialogOpen(`'${element.label}' 不能为空`);
        return;
      }
    }

    const rst = await this.props.functions.addRecord({
      data: this.state.recordInfo
    });
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "新增失败");
    } else if (rst.code === "success") {
      // this.setState({ recordInfo: {} });
      LocalStore.switchAddDialog();
      store.openMessageDialogOpen(rst.msg || "新增成功");
      store.search();
    }
  }

  updateRecord(key, value) {
    this.state.recordInfo[key] = value;
  }

  render() {
    return (
      <Dialog
        onClose={() => LocalStore.switchAddDialog()}
        open={LocalStore.addDialogOpen}
      >
        <DialogTitle id="addDialog" key='addDialog'>新增信息</DialogTitle>
        <DialogContent>
          {
            LocalStore.tableFields.map((row) => {
              if (!row.tobeCreatedField) return null;
              return (
                <ITextField
                  key={row.sid}
                  margin="dense"
                  id={row.sid}
                  label={row.label}
                  variant="standard"

                  ivalue={this.state.recordInfo[row.sid] || ''}
                  onChange={e => this.updateRecord(row.sid, e.target.value)}

                  type="text"
                  maxLength={row.maxLength || 20}
                  notNull={row.notEmptyWhenCreating || false}
                  style={{ width: '45%', marginLeft: '2%', marginRight: '2%' }}
                />
              );
            })
          }
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => this.addRecord(e)}
            color="primary"
            variant="contained"
          >
            确认新增
          </Button>
          <Button
            onClick={(e) => LocalStore.switchAddDialog()}
            color="primary"
            variant="contained"
          >
            取消
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const AddDialogObserver = observer(AddDialog);

AddDialogObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddDialogObserver);
